import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
}), 'KeyboardArrowUpSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardArrowUpSharp.js
// module id = 4329
// module chunks = 2